import * as React from 'react';
import { memo, SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="29"
    height="30"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 14.8536C0 7.7749 4.98013 1.87022 11.5968 0.514526V5.16978C7.87165 6.30449 5.06181 9.5692 4.55726 13.5609H9.03026C9.67035 11.1409 11.8749 9.35704 14.4961 9.35704C17.1174 9.35704 19.3219 11.1409 19.962 13.5609H24.4347C23.9302 9.5692 21.1203 6.30449 17.3952 5.16978V0.514527C24.0119 1.87022 28.992 7.7749 28.992 14.8536C28.992 22.9346 22.5019 29.4855 14.496 29.4855C6.49008 29.4855 0 22.9346 0 14.8536ZM24.3901 16.4601H19.962C19.4442 18.4175 17.903 19.9587 15.9456 20.4764V24.8623C20.2717 24.2295 23.7028 20.8068 24.3901 16.4601ZM13.0464 24.8623V20.4763C11.0891 19.9586 9.54801 18.4174 9.03028 16.4601H4.60188C5.28918 20.8068 8.72026 24.2295 13.0464 24.8623Z"
      fill="#FFC93E"
    />
  </svg>
);

const Memo = memo(SvgComponent);
export default Memo;
